import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleAccessoryPoliceHat = customSolarIconWrapper(<g transform="translate(12 35)">
	<path d="M56 57.5C50 27.5 66 5.5 108 5.5C150 5.5 166 27.5 160 57.5H56Z" fill="white" stroke="#202020" strokeWidth="11" strokeLinecap="round" strokeLinejoin="round" />
	<path d="M48 57.5H168" stroke="#202020" strokeWidth="11" strokeLinecap="round" />
	<path d="M98 25.5H118V34.5C111.333 40.5 108 43.5 108 43.5C108 43.5 104.667 40.5 98 34.5V25.5Z" stroke="#202020" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleAccessoryPoliceHat;
